import { createFileRoute } from "@tanstack/react-router";
import { CityLandingPage, buildCityLandingHead, type CityLandingConfig } from "@/components/CityLandingPage";

const CONFIG: CityLandingConfig = {
  slug: "parker",
  name: "Parker",
  region: "South Metro Denver",
  heroEyebrow: "Parker Marketing Hub",
  heroTitle: { lead: "Parker marketing for ", gold: "growing", trail: " south-metro businesses" },
  heroDescription:
    "Parker is one of Colorado's fastest-growing towns — new rooftops, high household incomes, and a buyer base that comparison-shops hard. We build websites, SEO, and Map Pack programs for trades, professional services, and Mainstreet retail.",
  intro:
    "Parker buyers are new homeowners with money and Google open. Word of mouth hasn't caught up to the growth, so being findable matters more than being legacy. Our Parker work prioritizes Map Pack visibility, mobile-first design, and review velocity.",
  neighborhoods: [
    "Mainstreet / Downtown Parker",
    "Stonegate",
    "Anthology",
    "Pinery",
    "Cottonwood",
    "Stroh Ranch",
    "Idyllwilde",
    "Reata North",
  ],
  marketSnapshot:
    "Parker's Map Pack is competitive and growing — new competitors open monthly, high-ticket categories (HVAC, roofing, dental, legal) attract chains, and incumbents have strong review counts. Wins come from review velocity and on-page depth.",
  highlights: [
    {
      title: "Built for new-build buyer behavior",
      body: "Parker buyers are 6 months into a new house with a list of contractors to find. We rank you for the searches that matter in those first 6 months.",
    },
    {
      title: "South metro service-area reach",
      body: "Most Parker businesses also serve Lone Tree, Castle Pines, Castle Rock, and Aurora's south edge. We rank you across the real footprint.",
    },
    {
      title: "Beat the chains on review recency",
      body: "National chains have volume, you have recency. We build review-request flows that keep your last 30 days fresh and outranking their old volume.",
    },
  ],
  services: [
    { to: "/parker-seo", title: "Parker SEO", body: "Map Pack rankings, on-page depth, and review velocity for Mainstreet and Stonegate-area service areas." },
    { to: "/web-design-parker-colorado", title: "Parker Web Design", body: "Custom websites engineered for Parker's new-build, comparison-shopping buyer base — fast, polished, mobile-first." },
    { to: "/parker-digital-marketing", title: "Digital marketing", body: "Integrated SEO, Ads, and GBP programs for Parker trades, professional services, and downtown retail." },
    { to: "/parker-geo-ai", title: "GEO / AI search", body: "Get cited in ChatGPT, Perplexity, and Google AI Overviews when Parker buyers ask AI." },
  ],
  learnArticleSlugs: [
    "/learn/local-seo-guide",
    "/learn/google-business-profile",
    "/learn/website-conversion",
    "/learn/get-more-reviews",
    "/learn/marketing-budget",
    "/learn/seo-vs-ppc",
  ],
  learnIntro:
    "Parker owners win by being the first answer when new homeowners Google. These six pieces explain how to be that answer.",
  closingCta:
    "30-minute call. We'll audit your Parker Map Pack position, identify the chains and new competitors pressuring you, and tell you what to fix first.",
};

export const Route = createFileRoute("/parker")({
  head: () =>
    buildCityLandingHead(CONFIG, {
      metaTitle: "Parker Marketing Agency | SEO, Web Design & Ads | CWI",
      metaDescription:
        "Parker SEO, web design, and Google Ads built for one of Colorado's fastest-growing towns. Local team, transparent reporting, no long-term contracts.",
    }),
  component: () => <CityLandingPage config={CONFIG} />,
});
